module.exports = __webpack_public_path__ + "img/acij.9cafac95.png";